// @unocss-include
import { useEffect, useState } from 'react';
export function useRotatingShuffledValue(options, intervalMs = 5000) {
    const [selected, setSelected] = useState(options ? options[Math.floor(Math.random() * options.length)] : undefined);
    useEffect(() => {
        if (options) {
            const interval = setInterval(() => {
                setSelected(options[Math.floor(Math.random() * options.length)]);
            }, intervalMs);
            return () => clearInterval(interval);
        }
    }, [options, intervalMs]);
    return selected;
}
//# sourceMappingURL=useRotatingShuffledValue.js.map